export const nounPath = (nounId: Number) => `/boun/${nounId}`;
